var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Modal from './ImageVideoModal';
import './style.scss';
import playButton from '../../assets/images/videoModal/play_button.png';
var VideoModalPlayer = function (data) {
    var _a = useState(false), isThumbnailClicked = _a[0], updateIsThumbnailClicked = _a[1];
    var _b = useState({}), modalHTML = _b[0], setModalHTML = _b[1];
    useEffect(function () {
        if (data.url.includes('vimeo')) {
            //Vimeo
            fetch("https://vimeo.com/api/oembed.json?url=" + data.url)
                .then(function (res) { return res.json(); })
                .then(function (data) {
                setModalHTML(data.html);
            });
        }
    }, []);
    var closeModal = function () {
        updateIsThumbnailClicked(false);
    };
    return (_jsxs(_Fragment, { children: [isThumbnailClicked && (_jsx(Modal, { closeModal: closeModal, url: data.url, html: modalHTML }, void 0)),
            _jsx("div", __assign({ className: "video-player-container relative flex-shrink-0 flex justify-center left-oriented" }, { children: _jsxs("div", __assign({ className: "video-player-link", onClick: function (e) {
                        e.preventDefault();
                        updateIsThumbnailClicked(true);
                    } }, { children: [_jsx("img", { src: playButton, className: "video-player-play-button" }, void 0),
                        _jsx("img", { className: "video-player-thumbnail", src: data.thumbnail }, void 0)] }), void 0) }), void 0)] }, void 0));
};
export default VideoModalPlayer;
